import ConcernsStudentSkill from './model';
import create from './create';

ConcernsStudentSkill.create = create;

export default ConcernsStudentSkill;



// WEBPACK FOOTER //
// ./data/AcademicInfo/ConcernsStudentSkill/index.js